import PropTypes from 'prop-types';

export const switchProps = PropTypes.shape({
  description: PropTypes.string.isRequired,
  ports: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired,
      }),
    ),
    PropTypes.shape({}),
  ]),
});

export const switchDataProps = PropTypes.arrayOf(switchProps).isRequired;

export const poweredDownPortsProps = PropTypes.arrayOf(
  PropTypes.number,
).isRequired;
